export default "__VITE_ASSET__735bbb59__"